const _ = require("lodash");
const moment = require("moment");
const datePattern = ["D-M-YY", "DD-MM-YY", "D/M/YY", "DD/MM/YY", "DD-MM-YYYY", "D-M-YY", "D/M/YYYY", "DD/MM/YYYY", "DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY hh:mm:ss", "DD/MM/YYYY hh:mm a", "DD/MM/YYYY h:m a", "D/M/YY hh:mm a", "D/M/YY h:m a", "DD/MM/YYYY hh:mma", "DD/MM/YYYY h:ma", "D/M/YYYY hh:mma", "D/M/YYYY h:ma", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm"]

export default [
    {
        name: 'ActiveStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'active', name: 'active' },
            { id: 'inactive', name: 'inactive' }
        ]
    },
    {
        name: 'AuditPreparationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'draft', name: 'draft' },
            { id: 'inPreparation', name: 'inPreparation' },
            { id: 'inRealization', name: 'inRealization' },
            { id: 'inFollowUp', name: 'inFollowUp' },
            { id: 'closed', name: 'closed' }
        ]
    },
    {
        name: 'AuditControlInstanceStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'inPreparation', name: 'inPreparation' },
            { id: 'inRealization', name: 'inRealization' },
            { id: 'inFollowUp', name: 'inFollowUp' },
            { id: 'pendingDecision', name: 'pendingDecision' },
            { id: 'closed', name: 'closed' },
            { id: 'notControlled', name: 'notControlled' },
            { id: 'notApplicable', name: 'notApplicable' }
        ]
    },
    {
        name: 'AuditWeight',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, {path: 'value', type: 'integer'}],
        objects: [
            { id: '1', value: 1 },
            { id: '2', value: 2 },
            { id: '3', value: 3 },
            { id: '4', value: 4 },
            { id: '5', value: 5 }
        ]
    },
    {
        name: "AuditConformityRate",
        type: "static",
        fields: [{ path: "id", type: "string" }, {path: "value", type: "integer"}, {path: "label", type: "string"}],
        objects: [
            { id: '0',   value: 0,   label: "0%"   },
            { id: '25',  value: 25,  label: "25%"  },
            { id: '50',  value: 50,  label: "50%"  },
            { id: '75',  value: 75,  label: "75%"  },
            { id: '100', value: 100, label: "100%" }
        ]
    },
    {
        name: "ObjectStatus",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
        ],
        objects: [
            {id: "active", name: "active"},
            {id: "suspended", name: "suspended"},
        ]
    },
    {
        name: "CondOperator",
        type: "static",
        fields: [
            "name",
            "tKey",
            "mongoSymbol"
        ],
        filters: [
            {
                name: "basicOperations",
                isDefault: false,
                match: (object) => !["000000000000000000000018", "000000000000000000000019"].includes(object.id)
            }
        ],
        objects: [
            {
                id: "000000000000000000000012",
                name: "greaterThan",
                tKey: "greaterThan",
                func: (value, otherValue) => value > otherValue,
                symbol: ">",
                mongoSymbol: "gt"
            },
            {
                id: "000000000000000000000013",
                name: "greaterThanOrEqualTo",
                tKey: "greaterThanOrEqualTo",
                func: (value, otherValue) => value >= otherValue,
                symbol: ">=",
                mongoSymbol: "gte"
            },
            {
                id: "000000000000000000000014",
                name: "lessThan",
                tKey: "lessThan",
                func: (value, otherValue) => value < otherValue,
                symbol: "<",
                mongoSymbol: "lt"
            },
            {
                id: "000000000000000000000015",
                name: "lessThanOrEqualTo",
                tKey: "lessThanOrEqualTo",
                func: (value, otherValue) => value <= otherValue,
                symbol: "<=",
                mongoSymbol: "lte"
            },
            {
                id: "000000000000000000000016",
                name: "equalTo",
                tKey: "equalTo",
                func: (value, otherValue) => value === otherValue,
                symbol: "==",
                mongoSymbol: "eq"
            },
            {
                id: "000000000000000000000017",
                name: "differentThan",
                tKey: "differentThan",
                func: (value, otherValue) => value !== otherValue,
                symbol: "!=",
                mongoSymbol: "ne"
            },
            {
                id: "000000000000000000000018",
                name: "includedIn",
                tKey: "includedIn",
                func: (value, otherValue) => otherValue.includes(value),
                symbol: "in",
                mongoSymbol: "in"
            },
            {
                id: "000000000000000000000019",
                name: "excludedFrom",
                tKey: "excludedFrom",
                func: (value, otherValue) => !otherValue.includes(value),
                symbol: "nin",
                mongoSymbol: "nin"
            },
            {
                id: "000000000000000000000020",
                name: "contains",
                tKey: "containsAtLeastOneValue",
                func: (value, otherValues) => otherValues?.some(v => value?.toLowerCase().includes(v?.toLowerCase())),
                symbol: "regexMatch",
                mongoSymbol: "regexMatch"
            },
            {
                id: "000000000000000000000021",
                name: "doesNotContain",
                tKey: "doesNotContainAnyValue",
                func: (value, otherValues) => !otherValues?.some(v => value?.toLowerCase().includes(v?.toLowerCase())),
                symbol: "negatedRegexMatch",
                mongoSymbol: "negatedRegexMatch"
            }
        ]
    },
    {
        name: "CondAggOperator",
        type: "static",
        fields: [
            "mongoOperator",
            "tKey"
        ],
        objects: [
            {id: "000000000000000000000001", tKey: "toDivide", mongoOperator: "$divide"},
            {id: "000000000000000000000002", tKey: "toMultiply", mongoOperator: "$multiply"},
            {id: "000000000000000000000003", tKey: "toAdd", mongoOperator: "$add"},
            {id: "000000000000000000000004", tKey: "toSubtract", mongoOperator: "$subtract"},
            {id: "000000000000000000000005", tKey: "toMod", mongoOperator: "$add"},
            {id: "000000000000000000000006", tKey: "toAverage", mongoOperator: "$add"},

        ]
    },
    {
        name: "Operation",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name"},
        ],
        objects: [
            {id: "000000000000000000000901", name: "distinctElementsNumber"}
        ]
    },
    {
        name: "DataType",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "tKey",
            {path: "isNumber", type: "boolean"}
        ],
        objects: [
            {
                id: "type-integer",
                tKey: "wholeNumber",
                code: "integer",
                cast: value => _.toInteger(value),
                validate: value => value !== "" && !_.isNaN(value) && _.isInteger(+value),
                isNumber: true
            },
            {
                id: "type-float",
                tKey: "realNumber",
                code: "float",
                cast: value => _.toNumber(value.replace(",", ".")),
                validate: value => value !== "" && ! isNaN(value.replace(",", ".")),
                isNumber: true
            },
            {
                id: "type-string",
                tKey: "text",
                code: "string",
                cast: value => value.toString(),
                validate: value => _.isString(value),
                isNumber: false
            },
            {
                id: "type-date",
                tKey: "date",
                code: "date",
                cast: value => moment(value, datePattern, true).isValid() ? moment.utc(value, datePattern).toDate() : value,
                validate: value => value === '0' || moment(value, datePattern, true).isValid(),
                isNumber: false
            }
        ]
    },

    {
        name: "ThemeFieldType",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "tKey",
            "code"
        ],
        objects: [
            {id: "000000000000000000000101", tKey: "amount_abreviation", code: "Mt"},
            {id: "000000000000000000000102", tKey: "number_abreviation", code: "Nb"}
        ]
    },
    {
        name: "RuleType",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "name", "name2"
        ],
        objects: [
            {id: "simple", name: "simpleRule", name2: "simpleCriterion"},
            {id: "ratio", name: "ratioRule", name2: "ratioCriterion"},
        ]
    },
    {
        name: "ConditionType",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "name",
            {path: "dataTypes", list: true}
        ],
        objects: [
            {id: "applyCondition", name: "applyCondition", dataTypes: ["type-integer", "type-float", "type-string"]},
            {id: "applyComparison", name: "applyComparison", dataTypes: ["type-integer", "type-float", "type-string"]},
            {id: "applyAttributeOperationCondition", name: "applyAttributeOperationCondition", dataTypes: ["type-integer", "type-float"]},
        ]
    },
    {
        name: "NumberConditionType",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "name"
        ],
        objects: [
            {id: "checkExistence", name: "checkExistence"},
            {id: "applyDataCondition", name: "applyDataCondition"},
            {id: "applyThemeCondition", name: "applyThemeCondition"},
        ]
    },
    {
        name: "TimeWindow",
        type: "static",
        fields: ["tKey", "period", "quantity"],
        objects: [
            {id: "00000000000000000000000a", tKey: "1_daily", period: "days", quantity: 1},
            {id: "00000000000000000000000b", tKey: "2_weekly", period: "days", quantity: 7},
            {id: "00000000000000000000000c", tKey: "3_monthly", period: "months", quantity: 1},
            {id: "00000000000000000000000d", tKey: "4_fiscalYear", period: "years", quantity: 1},
            {id: "000000000000000000000002", tKey: "8_calendarYear", period: "years", quantity: 1},
            {id: "00000000000000000000000e", tKey: "5_rollingWeek", period: "days", quantity: 7},
            {id: "00000000000000000000000f", tKey: "6_rollingMonth", period: "days", quantity: 30},
            {id: "000000000000000000000001", tKey: "7_rollingYear", period: "years", quantity: 1},
        ],
        filters: [
            {
                name: "noFiscalYear",
                isDefault: false,
                match: object => object.id !== "00000000000000000000000d"
            }
        ]
    },

    {
        name: "WeekDay",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "dayNumber", type: "integer"}
        ],
        objects: [
            {id: "sunday",      dayNumber: 0},
            {id: "monday",      dayNumber: 1},
            {id: "tuesday",     dayNumber: 2},
            {id: "wednesday",   dayNumber: 3},
            {id: "thursday",    dayNumber: 4},
            {id: "friday",      dayNumber: 5},
            {id: "saturday",    dayNumber: 6}
        ]
    },

    {
        name: "Month",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "name", type: "string"},
        ],
        objects: [
            {
                id: "01",
                order: 1,
                name: 'january'
            },
            {
                id: "02",
                order: 2,
                name: 'february'
            },
            {
                id: "03",
                order: 3,
                name: 'march'
            },
            {
                id: "04",
                order: 4,
                name: 'april'
            },
            {
                id: "05",
                order: 5,
                name: 'may'
            },
            {
                id: "06",
                order: 6,
                name: 'june'
            },
            {
                id: "07",
                order: 7,
                name: 'july'
            },
            {
                id: "08",
                order: 8,
                name: 'august'
            },
            {
                id: "09",
                order: 9,
                name: 'september'
            },
            {
                id: "10",
                order: 10,
                name: 'october'
            },
            {
                id: "11",
                order: 11,
                name: 'november'
            },
            {
                id: "12",
                order: 12,
                name: 'december'
            }
        ],
        sorters: [
            {
                name: 'byOrder',
                query: () => ({ order: 1 })
            }
        ]
    },

    {
        name: "MonthNumber",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {path: "dayNumber", type: "string"},
            {path: "order", type: "integer"}
        ],
        objects: _.range(28).map(dayNumber => {
            return {
                id: (dayNumber +1).toString(),dayNumber: (dayNumber +1).toString(), order: dayNumber + 1}
        }),
        sorters: [
            {
                name: 'byOrder',
                query: () => ({ order: 1 })
            }
        ]
    },

    {
        name: "MonthDay",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            {
                path: "dayNumber",
                type: "integer"
            },
            {
                path: "name",
                f: function() {
                    return this.dayNumber;
                }
            }
        ],
        objects: _.range(28).map(dayNumber => {
            return {
                id: "day-" + (dayNumber +1).toString(),dayNumber: dayNumber +1}
        })
    },

    {
        name: "StoreAxis",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [{id: "a00000000000000000000000", code: "store", name: "fr::magasin\nen::store", tKey: "store"}]
    },

    {
        name: "ProductAxis",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [{id: "b00000000000000000000000", code: "productCode", name: "fr::produit\nen::product", tKey: "product"}]
    },

    {
        name: "EmployeeAxis",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [{id: "d00000000000000000000000", code: "cashier", name: "fr::caissier\nen::cashier", tKey: "cashier"}]
    },

    {
        name: "TimeAxis",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [{id: "e00000000000000000000000", code: "date", name: "fr::temps\nen::time", tKey: "time"}]
    },

    {
        name: "CentralAxis",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [{id: "f00000000000000000000000", code: "central", name: "exhaustive", tKey: "exhaustive"}]
    },

    {
        name: "SubStoreAxisTheme",
        type: "static",
        fields: ["code", "name", "tKey"],
        objects: [
            {id: "d10000000000000000000000", code: "cashier", name: "cashier", tKey: "cashier"},
            {id: "e10000000000000000000000", code: "checkout", name: "checkout", tKey: "checkout"}
        ]
    },

    {
        name: "WorkflowFilter",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "tKey"
        ],
        objects: [
            {id: "alertToProcess", tKey: "1_alertToProcess"},
            {id: "alertInProgress", tKey: "2_alertInProgress"},
            {id: "closedAlertRisk", tKey: "3_closedAlertRisk"},
            {id: "closedAlertNoRisk", tKey: "4_closedAlertNoRisk"}
        ]
    },
    {
        name: "ThemeAnalyseCumulate",
        type: "static",
        fields: [
            {path: "id", type: "string"},
            "tKey"
        ],
        objects: [
            {id: "cumulate", tKey: "cumulate"},
            {id: "notCumulate", tKey: "notCumulate"}
        ]
    }
];
